/**
 * Der Foto-Knopf sitzt in der Schnelleingabe, der Assistent lebt im
 * schwebenden Mikro-Knopf. Beide stehen weit auseinander im Baum, und für
 * einen einzigen Knopf lohnt weder ein Zustandsspeicher noch ein Kontext.
 * Deshalb ein Ereignis am Fenster: eine Zeile zum Senden, eine zum Hören.
 */
const NAME = "ainkauf:zettel";

export function zettelGewaehlt(datei: File): void {
  window.dispatchEvent(new CustomEvent<File>(NAME, { detail: datei }));
}

export function aufZettel(horcher: (datei: File) => void): () => void {
  const handler = (event: Event) => {
    horcher((event as CustomEvent<File>).detail);
  };
  window.addEventListener(NAME, handler);
  return () => {
    window.removeEventListener(NAME, handler);
  };
}
